import React from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./formForm.data.form";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import {
  InputText,
  InputSelect,
  InputCheck,
  BreadCrumb,
  InputTextarea,
} from "@de-prado-dev/react-component-library";
import { PERSON_TYPES } from "../../../../constants";
import { ButtonDelete, ListField, ItemField } from "./formForm.styled";

const FormForm = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    handleSubmit,
    onBack,
    edit,
    onAddField,
    onRemoveField,
    fields,
    inputField,
    setInputField,
  } = props;
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.form.titleList"), path: PATHS.FORM_LIST },
    { label: t("forms.form.titleNew") },
  ];

  return (
    <>
      <div className="row justify-content-center mt-4 mt-md-5">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">
            {edit ? t("forms.form.titleEdit") : t("forms.form.titleNew")}
          </h3>
        </div>
      </div>
      {/* <BreadCrumb items={breads} /> */}
      <div className="row justify-content-center  ">
        <div className="col-12 col-md-11">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12">
                <Field
                  id="personType"
                  name="personType"
                  labelField={t("forms.requestProvider.labels.personType")}
                  component={InputSelect}
                  placeholder=""
                  optionLabel="label"
                  optionValue="code"
                  options={PERSON_TYPES.map((item) => ({
                    ...item,
                    label: t(item.label),
                  }))}
                  classNamePrefix="dark"
                  mandatory
                  isMultiple
                  addOptionEmpty
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="name"
                  className="form-control"
                  labelField={t("forms.form.labels.name")}
                  name="name"
                  placeholder=""
                  component={InputText}
                  fieldType="text"
                  mandatory
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="frontCode"
                  className="form-control"
                  labelField={t("forms.form.labels.frontCode")}
                  name="frontCode"
                  placeholder=""
                  component={InputText}
                  fieldType="text"
                  mandatory
                  readOnly
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <Field
                  id="active"
                  // className="form-control"
                  labelField={t("forms.form.labels.active")}
                  name="active"
                  placeholder=""
                  component={InputCheck}
                  mandatory
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Field
                  id="description"
                  className="form-control"
                  labelField={t("forms.form.labels.description")}
                  name="description"
                  placeholder=""
                  component={InputTextarea}
                />
              </div>
              <div className="col-6">
                <div className="row">
                  <div className="col-4 d-flex flex-column">
                    <label>{t("forms.form.labels.fields")}</label>
                    <div className="input-group mb-3">
                      <input
                        type="text"
                        value={inputField}
                        onChange={(e) => setInputField(e.target.value)}
                        className="form-control"
                        aria-label="Recipient's username"
                        aria-describedby="button-addon2"
                      />
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        id="button-addon2"
                        onClick={onAddField}
                      >
                        {t("forms.form.buttons.addField")}
                      </button>
                    </div>
                  </div>
                  <div className="col-8 d-flex flex-column mt-3">
                    <ListField>
                      {fields.map((item, index) => (
                        <ItemField
                          key={index}
                          className="d-flex justify-content-between"
                        >
                          {item}
                          <ButtonDelete
                            className="btn btn-sm btn-danger"
                            onClick={() => onRemoveField(index)}
                          >
                            <i className="fa-solid fa-xmark"></i>
                          </ButtonDelete>
                        </ItemField>
                      ))}
                    </ListField>
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onBack()}
                  className="btn btn-lg btn-secondary me-2"
                >
                  {t("forms.form.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-primary">
                  {t("forms.form.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

FormForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onback: PropTypes.func,
  edit: PropTypes.bool,
};

const FormFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "FormForm",
})(FormForm);

export default FormFormF;
